import React from 'react';
import { FormsyDate } from 'formsy-material-ui/lib';
import moment from 'moment';
import DatePickerWrapper from '../../common/Formsy/DatePickerWrapper';
import globals from '../../../globals/communityGlobals';
import _ from '../../../utils/lodash';
import { getDateForApi } from '../../../utils/dates';
import { recurrenceTypes } from '../../../settings/constants';

const clearIconStyle = {
  cursor: 'pointer',
  position: 'absolute',
  left: '-30px',
  top: '12px',
};

const locale = globals.getArea('treatments');

class ReviewDatePicker extends FormsyDate {
  constructor(props) {
    super(props);
    this.setEnhancedValidations();
  }

  nextSelectionMatrixEmpty = nextSelectionMatrix => {
    const keys = nextSelectionMatrix ? Object.keys(nextSelectionMatrix) : [];

    if (!keys.length) return true;

    return keys.every(index => nextSelectionMatrix[index] === undefined || nextSelectionMatrix[index] === null);
  };

  async componentWillReceiveProps(nextProps) {
    const { pattern, getPatternDates, selectionMatrix, treatmentId } = this.props;
    const { pattern: nextPattern, selectionMatrix: nextSelectionMatrix, timeSlotsPackageId } = nextProps;

    // Only make the request if either the pattern or the selection has changed
    // and we have a date to start from
    if (
      (!_.isEqual(pattern, nextPattern) || !_.isEqual(selectionMatrix, nextSelectionMatrix)) &&
      (nextPattern && nextPattern.dateFrom)
    ) {
      if (
        // Will throw an error if we try to send a Weekly/Monthly pattern with no days selected
        ((nextPattern.recurrenceType === recurrenceTypes.WEEKLY ||
          nextPattern.recurrenceType === recurrenceTypes.MONTHLY) &&
          this.nextSelectionMatrixEmpty(nextSelectionMatrix)) ||
        // Specific Time Weekly & Monthly patterns are mutually incompatible,
        // the query will throw an error if we send this request
        // so don't do it, user will have to select something to save the form anyway.
        // This has to be here because of the way the inputs are updated,
        // before the selection is cleared it still has the old value for a moment.
        (nextPattern.isSpecific &&
          // Switched either from monthly to weekly or the other way around
          // Daily works fine
          ((nextPattern.recurrenceType === recurrenceTypes.WEEKLY &&
            pattern.recurrenceType === recurrenceTypes.MONTHLY) ||
            nextPattern.recurrenceType === recurrenceTypes.MONTHLY ||
            (pattern.recurrenceType === recurrenceTypes.DAILY &&
              nextPattern.recurrenceType === recurrenceTypes.WEEKLY)) &&
          // Something is selected
          typeof nextSelectionMatrix !== 'undefined')
      ) {
        return;
      }
      await getPatternDates(treatmentId, nextPattern, nextSelectionMatrix, timeSlotsPackageId);
      this.setEnhancedValidations();
      // Trigger validation so we can inform the user if the current value is no longer valid
      // under the selected pattern
      this.setValue(this.getValue());
    }
  }

  isValidReviewDate = (values, value) => {
    if (typeof value === 'undefined') return true;

    return this.dateIsInsideKnownPattern(moment(value).startOf('day')) ? true : locale.getMsg('invalidReviewDate');
  };
  dateIsInsideKnownPattern = date => {
    const { pattern, matchingDates, selectionMatrix } = this.props;
    // Assume the date is fine if there's no start date set,
    // or if no days were selected for weekly/monthly patterns
    if (
      !pattern ||
      !pattern.dateFrom ||
      ((pattern.recurrenceType === recurrenceTypes.WEEKLY || pattern.recurrenceType === recurrenceTypes.MONTHLY) &&
        !selectionMatrix)
    )
      return true;
    return matchingDates ? matchingDates.includes(getDateForApi(date)) : true;
  };
  setEnhancedValidations = () => {
    this.setValidations(
      {
        isValidReviewDate: this.isValidReviewDate,
        ...this.props.validations,
      },
      this.props.required,
    );
  };
  getRequiredError = () => {
    const { isRequired, isPristine, isValid, isFormSubmitted } = this;

    return isRequired() && !isPristine() && !isValid() && isFormSubmitted() ? this.props.requiredError : null;
  };
  handleDateClear = () => {
    this.setValue(undefined);
  };
  shouldDisableDay = day => !this.dateIsInsideKnownPattern(day) || moment(day).isBefore(globals.now, 'day');
  render() {
    const {
      defaultDate,
      validations,
      validationErrors,
      validationError,
      requiredError,
      className,
      disabled,
      getPatternDates,
      matchingDates,
      isFetching,
      disableClear = false,
      timeSlotsPackageId,
      isFormValid,
      selectionMatrix,
      ...rest
    } = this.props;
    const value = this.getValue();
    const isDisabled = this.isFormDisabled() || disabled;
    const errorText = this.getErrorMessage() || this.getRequiredError();
    return (
      <div className={className}>
        <DatePickerWrapper
          disabled={isDisabled}
          className="ReviewDatePicker"
          style={{ width: '100%' }}
          formatDate={date => moment(date).format(globals.dateFormats.short)}
          {...rest}
          errorText={errorText}
          onChange={this.handleChange}
          ref={this.setMuiComponentAndMaybeFocus}
          value={value}
          shouldDisableDate={this.shouldDisableDay}
        />
        {!isDisabled && !disableClear && value && (
          <span style={{ position: 'absolute', width: '0', top: 0, right: 0 }}>
            <i
              tabIndex={0}
              role="button"
              className="allocateIcons"
              style={clearIconStyle}
              onClick={this.handleDateClear}
            >
              &#xE14C;
            </i>
          </span>
        )}
      </div>
    );
  }
}

export default ReviewDatePicker;
